import { render, staticRenderFns } from "./beforesale.vue?vue&type=template&id=3bf9d0ae&scoped=true"
import script from "./beforesale.vue?vue&type=script&lang=js"
export * from "./beforesale.vue?vue&type=script&lang=js"
import style0 from "./beforesale.vue?vue&type=style&index=0&id=3bf9d0ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf9d0ae",
  null
  
)

export default component.exports